import { v4 as uuid } from 'uuid'
import StorageManager from './StorageManager'
import { logger } from './logger'

export const ORDER_SESSION_ID_KEY = 'orderSessionId'
let _orderSessionId = null

export const getOrderSessionId = () => {
  if (_orderSessionId) {
    return _orderSessionId
  }

  if (StorageManager.get(ORDER_SESSION_ID_KEY)) {
    _orderSessionId = StorageManager.get(ORDER_SESSION_ID_KEY)
    return _orderSessionId
  } else {
    _orderSessionId = uuid()
    StorageManager.set(ORDER_SESSION_ID_KEY, _orderSessionId)
  }
}

export const resetOrderSessionId = () => {
  _orderSessionId = uuid()
  StorageManager.set(ORDER_SESSION_ID_KEY, _orderSessionId)
  logger.setTag(ORDER_SESSION_ID_KEY, _orderSessionId)
}
